import React, { Fragment } from "react";

import "./CategoryForm.css";
import "../../styles/uikit.css";
import "../../styles/font-awesome-4.7.0/css/font-awesome.min.css";

import Button from "../../components/Button/Button";
import { isNumber, required, length } from "../../util/validators";
import Input from "../../components/Form/Input/Input";
import Select from "react-select";

const options = [
  { value: "1", label: "سایز" },
  { value: "2", label: "رنگ" },
  { value: "3", label: "بدون رنگ یا سایز" },
];

const packaging = [
  { value: "1", label: "بسته بندی یکسان" },
  { value: "2", label: "بسته بندی متفاوت" },
];
const colourStyles = {
  control: (styles) => ({ ...styles, backgroundColor: "white" }),
  theme: (styles) => ({ ...styles, borderRadius: "8px" }),
};
class CategoryForm extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      categoryForm: {
        name: {
          value: props.isEditing ? props.parentCode.name : "",
          valid: props.isEditing ? true : false,
          errorMessage: "",
          touched: false,
          validators: [required, length({ min: 2 })],
        },
        secondName: {
          value: props.isEditing ? props.parentCode.secondName : "",
          valid: true,
          errorMessage: "",
          touched: false,
          validators: [],
        },
        enName: {
          value: props.isEditing ? props.parentCode.enName : "",
          valid: props.isEditing ? true : false,
          errorMessage: "",
          touched: false,
          validators: [required, length({ min: 2 })],
        },
        dataTheme: {
          value: props.isEditing ? options[props.parentCode.dataTheme-1] : "",
          valid: props.isEditing
            ? props.parentCode.dataTheme
              ? true
              : false
            : true,
          errorMessage: "",
          touched: false,
          validators: [required],
        },
        isUniformPackaging: {
          value: props.isEditing ? (props.parentCode.isUniformPackaging ? packaging[0] : packaging[1]) : "",
          valid: props.isEditing ? true : false,
          errorMessage: "",
          touched: false,
          validators: [required],
        },
      },
      isActive: true,
      displayOrder: 2,
      parentCode: parseInt(props.parentCode.code) || 0,
      formIsValid: props.isEditing ? true : false,
    };
    this.inputSelectChangeHandler = this.inputSelectChangeHandler.bind(this);
  }

  inputSelectChangeHandler(event, selector) {
    this.setState((prevState) => {
      let isValid = true;
      let errorMessage = "";
      for (const validator of prevState.categoryForm[selector.name].validators) {
        isValid = isValid && validator(event.value).hasError;
        errorMessage =
          !isValid && errorMessage === "" ? validator(event.value).errorMessage : errorMessage;
      }
      const updatedForm = {
        ...prevState.categoryForm,
        [selector.name]: {
          ...prevState.categoryForm[selector.name],
          valid: isValid,
          value: event,
          errorMessage: errorMessage,
        },
      };
      let formIsValid = true;
      for (const inputName in updatedForm) {
        formIsValid = formIsValid && updatedForm[inputName].valid;
      }

      return {
        categoryForm: updatedForm,
        formIsValid: formIsValid,
      };
    });
  }

  inputChangeHandler = (input, value) => {
    this.setState((prevState) => {
      let isValid = true;
      let errorMessage = "";
      for (const validator of prevState.categoryForm[input].validators) {
        isValid = isValid && validator(value).hasError;
        errorMessage =
          !isValid && errorMessage === "" ? validator(value).errorMessage : errorMessage;
      }
      const updatedForm = {
        ...prevState.categoryForm,
        [input]: {
          ...prevState.categoryForm[input],
          valid: isValid,
          value: value,
          errorMessage: errorMessage,
        },
      };
      let formIsValid = true;
      for (const inputName in updatedForm) {
        formIsValid = formIsValid && updatedForm[inputName].valid;
      }

      return {
        categoryForm: updatedForm,
        formIsValid: formIsValid,
      };
    });
  };

  inputBlurHandler = (input) => {
    this.setState((prevState) => {
      return {
        categoryForm: {
          ...prevState.categoryForm,
          [input]: {
            ...prevState.categoryForm[input],
            touched: true,
          },
        },
      };
    });
  };

  handleValidation() {
    if (this.state.formIsValid) {
      return true;
    }

    this.setState((prevState) => {
      let updatedForm = { ...prevState.categoryForm };
      for (const inputName in prevState.categoryForm) {
        let isValid = true;
        let errorMessage = "";
        if (inputName==="dataTheme" || inputName==="isUniformPackaging") {
          for (const validator of prevState.categoryForm[inputName].validators) {         
            isValid =
              isValid &&
              validator(prevState.categoryForm[inputName].value.value).hasError;
            errorMessage =
              !isValid && errorMessage === ""
                ? validator(prevState.categoryForm[inputName].value.value).errorMessage
                : errorMessage;
          }
        } else {
          for (const validator of prevState.categoryForm[inputName].validators) {          
            isValid =
              isValid &&
              validator(prevState.categoryForm[inputName].value).hasError;
            errorMessage =
              !isValid && errorMessage === ""
                ? validator(prevState.categoryForm[inputName].value).errorMessage
                : errorMessage;
          }
        }
        updatedForm = {
          ...updatedForm,
          [inputName]: {
            ...updatedForm[inputName],
            valid: isValid,
            errorMessage: errorMessage,
          },
        };
      }
      return {
        categoryForm: updatedForm,
      };
    });
  }

  contactSubmit(e) {
    e.preventDefault();
    if (this.handleValidation()) {
      this.props.onCreateCategory(e, this.state);
    }
  }

  render() {
    return (
      <Fragment>
        <div className="mn-grid__row mn-grid__row--gap-lg">
          <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--flex-initial">
            <h3 className="product-form__section-title product-form__section-title--dot">
              درج اطلاعات گروه کالایی جدید
            </h3>
          </div>
        </div>
        <form onSubmit={this.contactSubmit.bind(this)}>
          <div className="mn-grid__row mn-grid__row--gap-lg mn-grid__row--negative-gap-attr">
            <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--row-attr mn-grid__col--flex-initial mn-grid__col--sm-6">
              <Input
                id="name"
                label="عنوان اصلی گروه کالایی"
                type="text"
                control="input"
                required="required"
                onChange={this.inputChangeHandler}
                onBlur={this.inputBlurHandler.bind(this, "name")}
                value={this.state.categoryForm["name"].value}
                valid={this.state.categoryForm["name"].valid}
                touched={this.state.categoryForm["name"].touched}
                validationError={
                  !this.state.valid &&
                  this.state.categoryForm["name"].errorMessage
                }
              />
            </div>
            <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--row-attr mn-grid__col--flex-initial mn-grid__col--sm-6">
              <Input
                id="secondName"
                label="عنوان فرعی گروه کالایی"
                type="text"
                control="input"
                onChange={this.inputChangeHandler}
                onBlur={this.inputBlurHandler.bind(this, "secondName")}
                value={this.state.categoryForm["secondName"].value}
                valid={this.state.categoryForm["secondName"].valid}
                touched={this.state.categoryForm["secondName"].touched}
                validationError={
                  !this.state.valid &&
                  this.state.categoryForm["secondName"].errorMessage
                }
              />
            </div>
            <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--row-attr mn-grid__col--flex-initial mn-grid__col--sm-6">
              <Input
                id="enName"
                label="عنوان انگلیسی گروه کالایی"
                type="text"
                control="input"
                required="required"
                onChange={this.inputChangeHandler}
                onBlur={this.inputBlurHandler.bind(this, "enName")}
                value={this.state.categoryForm["enName"].value}
                valid={this.state.categoryForm["enName"].valid}
                touched={this.state.categoryForm["enName"].touched}
                validationError={
                  !this.state.valid &&
                  this.state.categoryForm["enName"].errorMessage
                }
              />
            </div>
            <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--row-attr mn-grid__col--flex-initial mn-grid__col--sm-6">
              <label
                htmlFor="dataTheme"
                className="uk-form-label uk-flex uk-flex-between"
              >
                {"تنوع مجاز برای این گروه کالایی"}
                <span className="uk-form-label__required"></span>
              </label>
              <div
              className={[
                  "field-wrapper",
                  this.state.categoryForm["dataTheme"].errorMessage === "" ? "" : "has-error",
                ].join(" ")}
              >   
                <Select
                  name="dataTheme"
                  control="input"
                  options={options}
                  theme={colourStyles.theme}
                  onChange={this.inputSelectChangeHandler}
                  onBlur={this.inputBlurHandler.bind(this, "dataTheme")}
                  value={this.state.categoryForm["dataTheme"].value}
                  valid={this.state.categoryForm["dataTheme"].valid}
                  touched={this.state.categoryForm["dataTheme"].touched}
                  validationError={
                    !this.state.valid &&
                    this.state.categoryForm["dataTheme"].errorMessage
                  }
                />
                <div id={1} className="error error-msg">
                  {this.state.categoryForm["dataTheme"].errorMessage}
                </div>
              </div>
            </div>
            <div className="mn-grid__col mn-grid__col--gap-lg mn-grid__col--row-attr mn-grid__col--flex-initial mn-grid__col--sm-6">
              <label
                htmlFor="isUniformPackaging"
                className="uk-form-label uk-flex uk-flex-between"
              >
                {"ابعاد بسته‌بندی برای این گروه کالایی"}
                <span className="uk-form-label__required"></span>
              </label>
              <div
              className={[
                  "field-wrapper",
                  this.state.categoryForm["isUniformPackaging"].errorMessage === "" ? "" : "has-error",
                ].join(" ")}
              >
              <Select
                name="isUniformPackaging"
                control="input"
                options={packaging}
                theme={colourStyles.theme}
                onChange={this.inputSelectChangeHandler}
                onBlur={this.inputBlurHandler.bind(this, "isUniformPackaging")}
                value={this.state.categoryForm["isUniformPackaging"].value}
                valid={this.state.categoryForm["isUniformPackaging"].valid}
                touched={this.state.categoryForm["isUniformPackaging"].touched}
              />
              <div id={2} className="error error-msg">
                {this.state.categoryForm["isUniformPackaging"].errorMessage}
              </div>
              </div>
              
            </div>
          </div>
          <Button
            design={this.props.isEditing ? "edit" : "next"}
            mode=""
            type="submit"
            loading={this.props.loading}
          >
            {this.props.isEditing ? "ویرایش گروه" : "درج گروه"}
          </Button>
        </form>
      </Fragment>
    );
  }
}

export default CategoryForm;
